export default {
    formId: 'createUsecaseForm',
    formField: {
        name: {
            name: 'name',
            requiredErrorMsg: 'Usecase name is required',
        },
        max_duration: {
            name: 'max_duration',
            requiredErrorMsg: 'Max duration is required',
        },
        environment_config_id: {
            name: 'environment_config_id',
            requiredErrorMsg: 'Environment configuration id is required',
        },
        main_area_name: {
            name: 'main_area_name',
            requiredErrorMsg: 'Main area name is required',
        },
        main_area_lat: {
            name: 'main_area_lat',
            requiredErrorMsg: 'Main area latitude is required',
            rangeErrorMsg: 'Latitude must be in the -90 to 90 range',
        },
        main_area_lon: {
            name: 'main_area_lon',
            requiredErrorMsg: 'Main area longitude is required',
            rangeErrorMsg: 'Longitude must be in the -180 to 180 range',
        },
        areas_array: {
            name: 'areas',
            fields: {
                name: { requiredErrorMsg: 'Area name is required' },
                type: { requiredErrorMsg: 'Area type is required' },
            },
        },
        payload_assets_array: {
            name: 'payload_assets',
            fields: {
                name: { requiredErrorMsg: 'Payload asset name is required' },
                type: { requiredErrorMsg: 'Payload asset type is required' },
                model: { requiredErrorMsg: 'Payload asset model is required' },
            },
        },
        platform_assets_array: {
            name: 'platform_assets',
            fields: {
                name: { requiredErrorMsg: 'Platform asset name is required' },
                type: { requiredErrorMsg: 'Platform asset type is required' },
                model: { requiredErrorMsg: 'Platform asset model is required' },
                sparq_id: { requiredErrorMsg: 'Platform asset sparq is required' },
            },
        },
        threats_array: {
            name: 'threats',
            fields: {
                name: { requiredErrorMsg: 'Threat asset name is required' },
                type: { requiredErrorMsg: 'Threat asset type is required' },
                model: { requiredErrorMsg: 'Threat asset model is required' },
                sparq_id: { requiredErrorMsg: 'Threat asset sparq is required' },
                alliance: { requiredErrorMsg: 'Threat asset alliance is required' },
            },
        },
    },
}
